import { ComponentPropsWithoutRef, forwardRef } from 'react';

type Props = ComponentPropsWithoutRef<'div'>;

const LNBAccountInfo = forwardRef<HTMLDivElement, Props>(({ children, ...props }, ref) => {
  return (
    <div {...props} ref={ref} className="ad_info">
      {children}
    </div>
  );
});

LNBAccountInfo.displayName = 'LNBAccountInfo';

export default LNBAccountInfo;
